<div class="tig-box">
	<h2>Firma suchen / anlegen</h2>

	<div class="form-group">
		<label>Kundennummer oder BA-ID</label>
		<input class="form-control" [(ngModel)]="companyKey" placeholder="z.B. 12345 oder BA12345" />
	</div>

	<button class="btn btn-primary" (click)="searchAndCreate()" [disabled]="loading">
		{{ loading ? 'Bitte warten…' : 'Suchen' }}
	</button>
</div>
